import { keymap } from 'prosemirror-keymap';

import { toggleUnderline } from '../commands';

const underlineKeymap = keymap({
	'Mod-u': toggleUnderline,
});

export default underlineKeymap;
